import React from "react";

import KudaLogo from "../../assets/images/png/partner-logo/Kuda-Bank.png";
import BambooLogo from "../../assets/images/png/partner-logo/bamboo.png";
import CowrywiseLogo from "../../assets/images/png/partner-logo/cowrywise.png";
import FlutterwaveLogo from "../../assets/images/png/partner-logo/flutterwave.png";
import MooveLogo from "../../assets/images/png/partner-logo/moove.png";
import PaystackLogo from "../../assets/images/png/partner-logo/paystack.png";
import PiggyvestLogo from "../../assets/images/png/partner-logo/piggyvest.png";
import TeamAptLogo from "../../assets/images/png/partner-logo/teamapt.png";

import AmazonLogo from "../../assets/images/png/partner-logo/amazon.webp";
import FacebookLogo from "../../assets/images/png/partner-logo/facebook.webp";
import GoogleLogo from "../../assets/images/png/partner-logo/google.jpg";
import MastercardLogo from "../../assets/images/png/partner-logo/mastercard.webp";
import PwCLogo from "../../assets/images/png/partner-logo/pwc.png";
import SamsungLogo from "../../assets/images/png/partner-logo/samsung.png";
import ShopifyLogo from "../../assets/images/png/partner-logo/shopify.png";
import SlackLogo from "../../assets/images/png/partner-logo/slack.png";
import StripeLogo from "../../assets/images/png/partner-logo/stripe.png";
import UberLogo from "../../assets/images/png/partner-logo/Uber.png";

import * as Animate from "react-reveal";

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel";

const partnerLogos = [
  GoogleLogo,
  AmazonLogo,
  FacebookLogo,
  UberLogo,
  MastercardLogo,
  ShopifyLogo,
  SlackLogo,
  StripeLogo,
  SamsungLogo,
  PwCLogo,
  FlutterwaveLogo,
  PaystackLogo,
  KudaLogo,
  PiggyvestLogo,
  MooveLogo,
  BambooLogo,
  CowrywiseLogo,
  TeamAptLogo,
];

const ImageCard = ({ image }) => (
  <div className="relative w-full h-16 object-contain">
    <img
      src={image}
      className="w-24 h-14 object-contain"
      alt=""
      loading="lazy"
    />
  </div>
);

const PartnerLogos = () => (
  <Animate.Fade bottom>
    {partnerLogos.map((logo, index) => (
      <ImageCard key={index} image={logo} />
    ))}
  </Animate.Fade>
);

const CoursePartnersLogoSection = ({ showNews = true }) => {
  return (
    <section className="pt-16 lg:pt-20 pb-20">
      <div className="container mx-auto px-4">
        <div className="mb-6 lg:mb-8">
          <Animate.Fade bottom>
            <p className="text-default text-lg font-mono font-medium">
              Our Talents Work With Many of these Leading Tech Companies
            </p>
          </Animate.Fade>
        </div>

        {/* Mobile Only */}
        <div className="block md:hidden">
          <OwlCarousel
            className="owl-carousel owl-theme"
            items={3}
            loop={true}
            autoplay={true}
            autoplayTimeout={2000}
            nav={false}
            dots={false}
            margin={28}
            stageClass="pt-5"
            responsiveClass={true}
            responsive={{
              0: {
                items: 3,
                nav: false,
              },
              600: {
                items: 3,
                nav: false,
              },
              1000: {
                items: 5,
                nav: false,
                loop: false,
              },
            }}
          >
            <PartnerLogos />
          </OwlCarousel>
        </div>

        {/* Desktop Only */}
        <div className="hidden md:grid grid-cols-3 md:grid-cols-5 lg:grid-cols-9 gap-x-8 gap-y-6 mx-auto items-center justify-center partners-logo-wrapper">
          <PartnerLogos />
        </div>

        {showNews && (
          <div className="flex flex-row items-center lg:items-baseline mt-8 lg:mt-10">
            <div className="font-medium text-xs pl-3 pr-2 py-2 text-white btn-new">
              NEW⚡
            </div>
            <p className="text-xs lg:text-sm text-primary pl-4 font-mono">
              HP Inc to support Utiva's mission to empower African women.{" "}
              <a
                href="https://www.csrwire.com/press_releases/739141-hp-utiva-and-girl-rising-set-move-more-girls-tech-kenya "
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold"
              >
                Read more
              </a>
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default CoursePartnersLogoSection;
